import { render, staticRenderFns } from "./AddAuthorPopup.vue?vue&type=template&id=44ca018c"
import script from "./AddAuthorPopup.vue?vue&type=script&lang=js"
export * from "./AddAuthorPopup.vue?vue&type=script&lang=js"
import style0 from "./AddAuthorPopup.vue?vue&type=style&index=0&id=44ca018c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports